import React from 'react'
import RDMAcadSearchBar from '../../../Components/RawData/ManageAcademies/RDMAcadSearchBar'
import styles from '../ManageAcademies/RDMAcadHome.module.css'

const RDMAcadHome = () => {
    return (
        <div className={styles.mainWrapper}>
            <div className={styles.mainContainer}>
                <div className={styles.leftCol}>
                    <RDMAcadSearchBar 
                        
                    />
                </div>
                <div className={styles.rightCol}>
                    RDMAcadHome
                </div>
            </div>
        </div>
    )
}

export default RDMAcadHome